import { Box, Icon, IconButton, Typography } from "@mui/material";
import trans from "helpers/trans";
import { useBasket, useBasketDispatch } from "./basketContext";
import BasketReducerActions from "./enums/BasketReducerActions";
import { FC } from "react";

type GuestQuantityProps = {};

const GuestQuantity: FC<GuestQuantityProps> = () => {
    const { guests, maxTickets } = useBasket();
    const basketDispatch = useBasketDispatch();
    return (
        <Box mb={1}>
            <Box display="flex" justifyContent="center" alignItems="center">
                <IconButton
                    onClick={() =>
                        basketDispatch?.({
                            type: BasketReducerActions.DECREASE_GUESTS,
                        })
                    }
                    disabled={guests === 0}
                    sx={{
                        ":hover": {
                            boxShadow: "none",
                            background: "#B97964",
                        },
                        width: { xs: 24, tablet: 28 },
                        height: { xs: 24, tablet: 28 },
                        background: "#B97964",
                        color: "#fff",
                        "&.Mui-disabled": {
                            backgroundColor: "rgb(185 121 100 / 0.26)",
                        },
                    }}
                >
                    <Icon sx={{ fontSize: { xs: 16, tablet: 18 } }}>
                        remove
                    </Icon>
                </IconButton>
                <Typography
                    sx={{
                        fontSize: { xs: 14, tablet: 16 },
                        fontWeight: 500,
                        px: 2,
                        fontFamily: "'Noto Sans', sans-serif",
                        color: "#02263A",
                    }}
                >
                    {trans(
                        guests !== 1
                            ? "event.webEvent.modal.ticketModal.guests"
                            : "event.webEvent.modal.ticketModal.guest",
                        {
                            guests: guests,
                        },
                    )}
                </Typography>

                <IconButton
                    onClick={() =>
                        basketDispatch?.({
                            type: BasketReducerActions.INCREASE_GUESTS,
                        })
                    }
                    disabled={guests === maxTickets}
                    sx={{
                        ":hover": {
                            boxShadow: "none",
                            background: "#B97964",
                        },
                        width: { xs: 24, tablet: 28 },
                        height: { xs: 24, tablet: 28 },
                        background: "#B97964",
                        color: "#fff",
                        "&.Mui-disabled": {
                            backgroundColor: "rgb(185 121 100 / 0.26)",
                        },
                    }}
                >
                    <Icon sx={{ fontSize: { xs: 16, tablet: 18 } }}>add</Icon>
                </IconButton>
            </Box>
        </Box>
    );
};

export default GuestQuantity;
